import { Grid, List, Plus, Copy, Scissors, Trash } from "lucide-react";
import { ViewMode } from "../types";

interface ToolbarProps {
    viewMode: ViewMode;
    onViewModeChange: (mode: ViewMode) => void;
}

export const Toolbar = ({ viewMode, onViewModeChange }: ToolbarProps) => {
    return (
        <div className="bg-gray-800 text-white p-2 flex items-center space-x-2">
            <button className="p-1 rounded hover:bg-gray-700">
                <Plus className="w-5 h-5" />
            </button>
            <button className="p-1 rounded hover:bg-gray-700">
                <Copy className="w-5 h-5" />
            </button>
            <button className="p-1 rounded hover:bg-gray-700">
                <Scissors className="w-5 h-5" />
            </button>
            <button className="p-1 rounded hover:bg-gray-700">
                <Trash className="w-5 h-5" />
            </button>
            <div className="h-5 border-l border-gray-600 mx-1"></div>
            <button
                className={`p-1 rounded hover:bg-gray-700 ${viewMode === "grid" ? "bg-gray-700" : ""}`}
                onClick={() => onViewModeChange("grid")}>
                <Grid className="w-5 h-5" />
            </button>
            <button
                className={`p-1 rounded hover:bg-gray-700 ${viewMode === "list" ? "bg-gray-700" : ""}`}
                onClick={() => onViewModeChange("list")}>
                <List className="w-5 h-5" />
            </button>
        </div>
    );
};
